import {
	useMutation,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { Api } from "../api.config";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { QueryKeys } from "../LinkGen";
import { useCompany } from "./useCompany";

export const useMarketingPlan = () => {
	const { id: companyId } = useCompany();

	const { data } = useSuspenseQuery({
		queryKey: QueryKeys.Company.MarketingPlan(companyId),
		queryFn: () => Api.MarketingPlan().then((x) => x.data),
	});

	return data;
};

export function useMarketingPlanActions() {
	const queryClient = useQueryClient();
	const emit = useAlertEmit();
	const { id: companyId } = useCompany();

	return {
		generatePlan: useMutation({
			mutationFn: async () => {
				const newPlan = await Api.GenerateMarketingPlan().then((x) => x.data);

				queryClient.setQueryData(
					QueryKeys.Company.MarketingPlan(companyId),
					() => newPlan,
				);

				emit({
					type: AlertType.SUCCESS,
					content: "Marketing Plan has been generated.",
				});

				return newPlan;
			},
			onError: (e) => {
				emit({
					type: AlertType.ERROR,
					content: isAxiosError(e)
						? e.response?.data?.message
						: "An unexpected error occurred.",
				});
			},
		}),
		save: useMutation({
			mutationFn: async (plan: string) => {
				const newPlan = await Api.SaveMarketingPlan(plan);

				queryClient.setQueryData(
					QueryKeys.Company.MarketingPlan(companyId),
					() => newPlan,
				);

				return newPlan;
			},
			onError: (e) => {
				emit({
					type: AlertType.ERROR,
					content: isAxiosError(e)
						? e.response?.data?.message
						: "An unexpected error occurred.",
				});
			},
		}),
	};
}
